<template>
  <div class="service-wrap pt-20 pb-20">
    <div class="container">
      <!-- En-tête -->
      <div class="row mb-5">
        <div class="col-12 text-center">
          <div class="text-wrapper">
            <p
              class="section-text"
              :class="{ collapsed: !isExpanded }"
            >
              Vous serez appelés d’un nom nouveau : Disciples d’Emmaüs
                Le chrétien, en Afrique comme dans le monde, est souvent bouleversé ou désemparé par la complexité de divers problèmes existentiels à affronter. Se sentant bien des fois démuni et abandonné, le disciple du Christ est parfois déçu ou même vaincu par de nombreux défis sociopolitiques et culturels. Au regard de ces enjeux, l’École d’Initiation Théologique et Pastorale (EITP) de l’archidiocèse de Cotonou compte modestement, par la mise en relation dynamique et organique de la foi avec la raison et les cultures, se constituer comme le chemin où le croyant marche aux côtés de Jésus-Christ. Le Christ est vraiment Celui qui n’abandonne jamais l’homme seul sur sa route de doute ou de désespoir ; Il chemine plutôt avec lui et le guide par la lumière de sa Divine Parole. A travers les données essentielles de la foi à approfondir afin de pouvoir en rendre convenablement compte, c’est l’expérience de l’heureuse rencontre avec le Christ qui est proposée.
                Aussi le cheminement à l’EITP peut-il être comparé à la route parcourue par les deux disciples du Christ (Lc 24), partis de Jérusalem vers Emmaüs, mais rejoints par le Ressuscité qui les instruit et les nourrit. Les yeux de leur intelligence de la foi se sont ainsi ouverts pour reconnaître leur Seigneur et Sauveur, à la fraction du pain. La culture de la foi requiert la vie des mystères de la foi.
                Après la rencontre avec le Crucifié Ressuscité, les disciples d’Emmaüs s’engagent, à l’instant et désormais, sur les chemins du témoignage, aujourd’hui plus nombreux et divers, pour annoncer la Bonne Nouvelle de la victoire de l’amour sur la haine, de la vie sur la mort, de la lumière sur les ténèbres. A nous d’en être les témoins crédibles, partout et toujours. L’EITP voudrait alors nous aider à devenir les nouveaux Disciples d’Emmaüs, véritables chercheurs de Dieu dont a tant besoin le monde de notre temps.
               <br> Les Disciples suivent toute la formation (deux années) et valident tous les modules autant par la présence que par les devoirs et l’examen final. Ils publient un mémoire et une authentification de fin de formation à la Cérémonie académique. Ils sont envoyés  en mission lors d’une messe.
              <!-- (garde tout ton texte complet ici sans le couper) -->
            </p>

            <button class="toggle-btn" @click="isExpanded = !isExpanded">
              {{ isExpanded ? "Voir moins" : "Voir plus" }}
            </button>
          </div>

        </div>
        <div>
            <!-- <h3 class="section-title">Disciples d’Emmaüs</h3> -->
            <p class="section-text">
              
            <br><br>
            </p>
        </div>
        
        <div class="search-wrapper mb-4">
          <form class="search-box" @submit.prevent="rechercher">
            <input
              type="text"
              v-model="searchTerm"
              @input="rechercher"
              placeholder="Rechercher un disciple (nom ou prénom)..."
            />
            <button type="submit">
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
        </div>

        </div>
          <div class="row g-4">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-6"
              v-for="etu in etudiants"
              :key="etu.id"
            >
              <div class="prof-mini-card">
                <img
                  v-if="etu.user?.urlImage"
                  :src="getImageUrl(etu.user.urlImage)"
                  alt="Photo disciple"
                  class="prof-photo"
                />

                <img
                  v-else
                  :src="defaultPhoto"
                  alt="Photo par défaut"
                  class="prof-photo"
                />
                <h5 class="prof-mini-name">
                  <router-link
                    :to="`/disciplesEmmaius/${etu.id}`"
                    class="prof-link"
                  >
                    {{ etu.nom }} {{ etu.prenom }}
                  </router-link>
                </h5>
              </div>
            </div>
          </div>
          <div class="mt-4">
          <PaginationComponent
            :page="page"
            :totalPages="totalPages"
            :totalElements="totalElements"
            :limit="limit"
            @paginate="handlePaginate"
          />
        </div>
      </div> 
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/services/ApiService";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import debounce from "lodash/debounce";

interface Etudiant {
  id: number;
  nom: string;
  prenom: string;
  photo: string;
  autreQualification:string
 user?:User
}
interface User {
  urlImage?: string
}


export default defineComponent({
  name: "LesDisciplesEmmaus",
  components: { PaginationComponent },

  setup() {
    const etudiants = ref<Etudiant[]>([]);
    const defaultPhoto = "/22.png";

    const page = ref(1);
    const limit = ref(12);
    const totalPages = ref(0);
    const totalElements = ref(0);
    const searchTerm = ref('');
    const isExpanded = ref(false);
   

    // Pagination handler
    const handlePaginate = ({ page_: newPage, limit_: newLimit }) => {
      page.value = newPage;
      limit.value = newLimit;
      getTreeDisciples(newPage, newLimit);
    };
    function rechercher(){
      getTreeDisciples(page.value, limit.value, searchTerm.value );
    }
    // Chargement des étudiants
    const getTreeDisciples = async (pageNum = 1, limi = 12, searchTerm='') => {
      try {
        const { data } = await ApiService.get(
          `/etudiants/categorie/Disciple?page=${pageNum}&limit=${limi}&mot=${searchTerm}&`
        );
        etudiants.value = data.data.data;
        console.log("gggg",etudiants.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;

      } catch (error) {
        console.error("Erreur chargement disciples :", error);
      }
    };
    function getImageUrl(filename?: string) : string {
      if (!filename) return ''
      return `${ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0]}uploads/Users/${filename}`; }

    // Chargement initial
    onMounted(() => {
      getTreeDisciples(page.value, limit.value);
    });

    return {
      etudiants,
      defaultPhoto,
      page,
      limit,
      totalPages,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      getImageUrl,
      isExpanded
    };
  },
});
</script>


<style scoped>
 
  .prof-mini-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 6px 18px rgba(0,0,0,0.1);
  transition: 0.3s;
}

.prof-mini-card:hover {
  transform: translateY(-6px);
}

.prof-photo {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #ffc107;
  margin-bottom: 10px;
}

.prof-mini-name {
  font-weight: 800;
  color: #0b1b3f;
  cursor: pointer;
}

.prof-mini-name:hover {
  color: #ffc107;

  .year-simple {
  margin-bottom: 20px;
}

.year-title {
  font-weight: 800;
  color: #0b1b3f;
}

.matiere-list {
  padding-left: 18px;
}

.matiere-list li {
  list-style: disc;
  padding: 3px 0;
}
.prof-link {
  text-decoration: none;
  color: inherit;
}

.prof-link:hover {
  color: #ffc107;
}

}

.search-wrapper {
  display: flex;
  justify-content: flex-start;
}

.search-box {
  position: relative;
  width: 100%;
  max-width: 380px;
}

.search-box input {
  width: 200%;
  height: 48px;
  padding: 0 50px 0 18px;
  border-radius: 15px;
  border: 2px solid #e6e6e6;
  font-size: 20px;
  color: #0b1b3f;
  transition: all 0.3s ease;
  background-color: #fff;
}

.search-box input::placeholder {
  color: #999;
  font-size: 20px;
}

.search-box input:focus {
  outline: none;
  border-color: #ffc107;
  box-shadow: 0 0 0 4px rgba(255, 193, 7, 0.15);
}

.search-box button {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #ffc107;
  font-size: 18px;
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
}

.search-box button:hover {
  color: #0b1b3f;
  transform: translateY(-50%) scale(1.1);
}

/* Responsive */
@media (max-width: 576px) {
  .search-wrapper {
    justify-content: center;
  }

  .search-box {
    max-width: 100%;
  }
}

.text-wrapper {
  position: relative;
  text-align: left;
}

.section-text {
  font-size: 20px;
  line-height: 1.6;
  transition: all 0.3s ease;
  text-align: justify;
}

/* État réduit */
.section-text.collapsed {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 🔥 2 lignes seulement */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.toggle-btn {
  background: none;
  border: none;
  color: #ffc107;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  padding: 0;
  font-size: 16px;
  transition: color 0.3s ease;
}

.toggle-btn:hover {
  color: #0b1b3f;
}

</style>